import { render, staticRenderFns } from "./pending-orders-products.vue?vue&type=template&id=477c386d&scoped=true"
import script from "./pending-orders-products.vue?vue&type=script&lang=ts"
export * from "./pending-orders-products.vue?vue&type=script&lang=ts"
import style0 from "./pending-orders-products.vue?vue&type=style&index=0&id=477c386d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c386d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477c386d')) {
      api.createRecord('477c386d', component.options)
    } else {
      api.reload('477c386d', component.options)
    }
    module.hot.accept("./pending-orders-products.vue?vue&type=template&id=477c386d&scoped=true", function () {
      api.rerender('477c386d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/pending-orders-products.vue"
export default component.exports